import './styles/home.css'

import { Link } from 'react-router-dom'

import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

//Components
import { AiOutlineControl } from "react-icons/ai"
import { GoPeople } from "react-icons/go"
import { PiChalkboardTeacher } from "react-icons/pi"
import { LiaLayerGroupSolid } from "react-icons/lia"
import Loader from '../components/loader'

//Extras
import { main, fontType } from '../assets/extras'
import { version } from '../assets/datas'

const Home = () => {

    document.title = "Tenista Dashboard"

    const [ variables, setVariables ] = useState({
        loading: true,
        ref: null,
        academia: null,
        nombre_academia: ""
    })

    const navigate = useNavigate()

    const getReference = (token, academia) => {
        sessionStorage.setItem("homeFlag", true)
        
        setVariables(prev => ({
            ...prev,
            ref: token.ref,
            academia: academia,
            nombre_academia: token.nombre_academia,
            loading: false
        }))
    }

    useEffect(() => {
        var token = localStorage.getItem("authToken")

        if(token) {
            token = JSON.parse(token)

            getReference(token, token.academia)
        } else {
            navigate("/login", {replace: true})
        }
    }, [])

    if(variables.loading)
        return (
            <Loader loading={variables.loading} />
        )

    if(!variables.loading)
    return (
        <div className='mainHome'>

            <h2 style={{
                fontFamily: fontType.title,
                backgroundColor: main
            }}>{variables.nombre_academia === "" ? "MENU" : variables.nombre_academia}</h2>
            
            <div className='contMenu' style={{
                fontFamily: fontType.text
            }}>

                <Link to="/controlpanel" state={{
                    ref: variables.ref,
                    academia: variables.academia
                }} className='item'>
                    <AiOutlineControl size={60} />
                    <h3>ADMINISTRACION</h3>
                </Link>

                <Link to='/players' state={{
                    ref: variables.ref,
                    academia: variables.academia,
                    nombreAcademia: variables.nombre_academia
                }} className='item'>
                    <GoPeople size={60} />
                    <h3>JUGADORES</h3>
                </Link>

                <Link to="/teachers" state={{
                    ref: variables.ref,
                    academia: variables.academia
                }} className='item'>
                    <PiChalkboardTeacher size={60} />
                    <h3>PROFESORES</h3>
                </Link>

                <Link to="/classes" state={{
                    ref: variables.ref,
                    academia: variables.academia
                }} className='item'>
                    <LiaLayerGroupSolid size={60} />
                    <h3>CLASES</h3>
                </Link>

                <p style={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    padding: 2,
                    color: "gray"
                }}>{version}</p>
                
            </div>
        </div>
    )
}

export default Home